import ApiService from './api.service'

const Analytics = {
	getAllIncomes(data){
		return ApiService.post(`/report/whdoc-list`,data);
	},
	getSaleList(data){
		return ApiService.post(`/report/sale-list`,data);
	},
	getSaleListByDate(data){
		return ApiService.post(`/report/sale-by-date`,data);
	},
	getMonthlySaleList(data){
		return ApiService.post(`/report/monthly-sale-list`,data);
	},

	productInDateRange(data){
		return ApiService.post(`/report/by-item`,data);
	}


};
export default Analytics;
